import React, { useState } from "react";
import { Card, Paper } from "@material-ui/core";
import styled from "styled-components";
import logo from '../images/imtbike_logo.jpg';
import {
  Create,
  Edit,
  SimpleForm,
  DateInput,
  TextInput,
  SaveButton,
  DeleteButton,
  Toolbar,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  Link,
  ReferenceManyField,
  Datagrid,
  TextField,
  TabbedForm,
  FormTab,
  LongTextInput,
  FormDataConsumer,
  FunctionField,
  List,
  GET_LIST,
  Button
} from "react-admin";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import dataProviderFactory from "../dataProvider";

import moment, { now } from "moment";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from '@material-ui/icons/Delete';
// import LinearProgress from "@material-ui/core/LinearProgress";

import { isNil, find, propEq, isEmpty, map, prop } from "ramda";

import Print from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import { getPermissionRole } from "../util";


const ComponentToPrint = styled.div`
  display: flex;
`;

const LogoPrint = styled.div`
  padding-top: 1rem;
  padding-left: 1rem;
`;

const DatosPrint = styled.div`
  padding-left: 1rem;
`;

const ButtonCustom = styled(Button)`
  color: #f44336 !important;
  :hover {
    background-color: rgba(244, 67, 54, 0.12) !important;
  }
`

const validateForm = values => {
  const errors = {};
  if (!values.transfer_date) {
    errors.transfer_date = ["Transfer Date is required"];
  } /*else {
    if (moment(values.transfer_date).isBefore(Date.now())) {
      errors.transfer_date = ["Transfer Date must be later then current date"];
    }
  }*/

  if (!values.setup_date) {
    errors.setup_date = ["Delivery Date is required"];
  }
  if (values.transfer_date && values.setup_date) {
    if (
      moment(values.transfer_date).diff(moment(values.setup_date), "days") > 0
    ) {
      errors.setup_date = [
        "Delivery Date must be later or equal then transfer date"
      ];
    }
  }
  return errors;
};
function handleChange (element, type) {
  //console.log(element.target)
  if (element.target === undefined){
    if(document.getElementById('transfer_date') === type){
      //console.log('se cambio')
      const date1 = document.getElementById('transfer_date')
      const newDate2 = moment(date1.value).add(1,'day').format("YYYY-MM-DD")
      const date2 = document.getElementById('setup_date')
      date2.min = date1.value
      date2.value = newDate2
      //this.setState({ date_2: newDate2 })
    }
    else if (type === 'transfer_date_edit'){
      //console.log('se cambio 2')
      const date1 = document.getElementById('transfer_date_E')
      const newDate2 = moment(date1.value).add(1,'day').format("YYYY-MM-DD")
      const date2 = document.getElementById('setup_date_E')
      date2.min = date1.value
      date2.value = newDate2
    }
  }
  else{
    if(element.target.id === "transfer_date"){
      //console.log('se cambio')
      const newDate2 = moment(element.target.value).add(1,'day').format("YYYY-MM-DD")
      const date2 = document.getElementById('setup_date')
      date2.min = element.target.value
      date2.value = newDate2
      //this.setState({ date_2: newDate2 })
    }
  }
}

export const TransferCreate = props => (
  <Create title="Create" {...props}>
  <SimpleForm redirect="edit" validate={validateForm}>
  <TextInput id="transfer_date"
              label="Transfer Date" type="date" name="transfer_date" source="transfer_date"
              onChange={e => handleChange(e, "transfer_date")}  locales="es-Es" options={{ timeZone: 'UTC' }}  
              defaultValue={moment(null).format("YYYY-MM-DD")}
              InputLabelProps={{shrink: true }} 
            />
     <DateInput label="Delivery Date" source="setup_date" id="setup_date" locales="es-Es" options={{ timeZone: 'UTC' }}  />
     <TextInput label="Agent" source="agent" />

     <ReferenceInput
  label="Origin"
  source="location_id_1"
  reference="locations"
  filter={{ only_bases: "true" }}
  sort={{ field: "location_name", order: "ASC" }}
>
<SelectInput optionText="location_name" />
</ReferenceInput>

<ReferenceInput
          label="Destination"
          source="location_id_2"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
  <SelectInput optionText="location_name" />
        </ReferenceInput>

     <LongTextInput label="Notes" source="notes" />
 
  </SimpleForm>
</Create>
);

const TranferEditTitle = object => (
  <span>
    {" Edit Transfer - " +
      moment(object.record.transfer_date).format("DD-MM-YYYY") +
      "-" +
      object.record.id}
  </span>
);

const CustomDeleteTransferIten = props => {
  return (
    <DeleteButton
      undoable={false}
      basePath={props.basePath}
      record={props.record}
      resource={props.resource}
      redirect={`/transfers/${props.record.transfer_id}`}
    />
  );
};

const formatDate = date => new Date(date != null ? date : new Date()).toISOString().slice(0, 10);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const DeleteButtonEditConfirm = props => {
  const [open, setOpen] = useState(true);
  console.log(props)
  function handleClose() {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} {...props}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this transfer?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" label="Cancel"/>
        <DeleteButton
            basePath={props.basePath}
            record={props.record}
            resource={props.resource}
            redirect={`/transfers`}
          />
      </DialogActions>
    </Dialog>
  )
}

const TransferEditToolbar = (props, redirect) => { 
  const location = props.location
  let link = (miga == '/undefined') ? '/transfers' : miga 
  
  const [open, setOpen] = useState(false);

  function handleDeleteClick() {
    setOpen(true);
  };

  return (
    <Toolbar {...props}>
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) && 
        <React.Fragment>
          <SaveButton {...props} redirect={{ link }}/>
          &nbsp;
          <ButtonCustom onClick={handleDeleteClick} label="Delete" >
            <DeleteIcon />
          </ButtonCustom>    
          {open && <DeleteButtonEditConfirm {...props} onClose={() => setOpen(false)} />}
        </React.Fragment>
      )}
      <Button
        component={Link}
        to={{
          pathname: `/transfers`
        }}
        label="Back to Transfers"
      >
        <ArrowBackIcon />
      </Button>
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) && 
        <Button
          component={Link}
          to={{
            pathname: "/transfer_items/create",
            search: `?transfer_id=${props.record.id}&location_id_1=${props.record.location_id_1
              }&location_id_2=${props.record.location_id_2}&transfer_date=${moment(
                props.record.transfer_date
              ).format("YYYY-MM-DD")}&setup_date=${moment(
                props.record.setup_date
              ).format("YYYY-MM-DD")}`,
          }}
          label="Add Transfer Item"
        >
          <AddIcon />
        </Button>
      )}
    </Toolbar>
)};



// const EditTransferItemButton = object => {
//   return (
//     <EditButton
//       component={Link}
//       to={{
//         pathname: `/transfer_items/${object.record.id}`,
//         search: `?transfer_id=${object.record.transfer_id}&location_id_1=${
//           object.record.transfer.location_id_1
//         }&location_id_2=${
//           object.record.transfer.location_id_2
//         }&transfer_date=${moment(object.record.transfer.transfer_date).format(
//           "YYYY-MM-DD"
//         )}&setup_date=${moment(object.record.transfer.setup_date).format(
//           "YYYY-MM-DD"
//         )}`
//       }}
//       label="Edit"
//     ></EditButton>
//   );
// };

const CustomColumn = ({ className, record = {}, ...rest }) => {
  if (record.item_type === "vehicle") {
    return (
      <ReferenceField
        {...{ className, record, ...rest }}
        source="item_id"
        reference="vehicles"
        linkType={false}
      >
        {/* <TextField source="licence_plate" /> */}
        <FunctionField render={(record) => {
          return (
            <span>{record.model.model_name} - {record.licence_plate} {record.renting ? "®" : ""}</span>
          )
        }} />
      </ReferenceField>
    );
  }
  if (record.item_type === "gps_device" || record.item_type === "helmet") {
    const item = `${record.item_type}s`;
    return (
      <ReferenceField
        {...{ className, record, ...rest }}
        source="item_id"
        reference={item}
        linkType={false}
      >
        <TextField source="model" />
      </ReferenceField>
    );
  }

  if (
    record.item_type === "seat" ||
    record.item_type === "glove" ||
    record.item_type === "jacket" ||
    record.item_type === "tankbag"
  ) {
    const item = `${record.item_type}s`;
    return (
      <ReferenceField
        {...{ className, record, ...rest }}
        source="item_id"
        reference={item}
        linkType={false}
      >
        <TextField source="model" />
      </ReferenceField>
    );
  }
  return null;
};
let miga = ''
class AsyncComponent extends React.Component {
  constructor(props) {
    super(props);
    this.offset = 0;
    this.state = {
      data: [],
      problemVehicles: [],
      problemGpsDevices: [],
      loading: "doing"
    };
    this.componentRef = React.createRef();
  }

  async getAllData() {
    let defaultItemType = "vehicle";

    if (this.props.formData.item_type) {
      defaultItemType = this.props.formData.item_type;
    }

    const {
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date,
      id
    } = this.props.formData;
    const dataItems = await this.getDataFor(
      defaultItemType,
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date,
      id
    );

    const gpsDevices = await this.getDataFor(
      "gps_device",
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date,
      id
    );

    const problemVehicles = this.checkVehicles(
      dataItems || [],
      this.props.formData.vehicles
    );

    const problemGpsDevices = this.checkGpsDevices(
      gpsDevices || [],
      this.props.formData.gps_devices || []
    );

    const data = {
      vehicles: dataItems,
      gps_devices: gpsDevices,
      problemVehicles,
      problemGpsDevices,
      loading: "done"
    };
    this.setState(data);
  }

  async getDataFor(
    itemType,
    locationID1,
    locationID2,
    transferDate,
    setup_date,
    id
  ) {
    let data = [];
    if (itemType) {
      const dataProvider = await dataProviderFactory("rest");
      let itemStatus = "1";
      let sortField = "id";
      let orderBY = "DESC";
      if (itemType === "vehicle") {
        itemStatus = "A";
      }

      if (itemType === "gps_device") {
        sortField = "model";
        orderBY = "ASC";
        itemStatus = "A";
      }

      // const filterItems =
      // itemType === "vehicle" ? "vehicles/by_event" : itemType;

      const response = await dataProvider(GET_LIST, itemType + "s", {
        filter: {
          from: "",
          to: "",
          status: itemStatus,
          location_id_1: locationID2,
          date_1: transferDate,
          date_2: setup_date,
          transfer_availability: "true",
          transfer_id: id
        },
        pagination: {
          page: 1,
          perPage: 999
        },
        sort: { field: sortField, order: orderBY }
      });
      response.data.map(function (item) {
        if (itemType !== "vehicle") {
          return data.push({ id: item.id, description: item.model });
        } else {
          return data.push({
            id: item.id,
            licence_plate: item.licence_plate
          });
        }
      });
    }

    return data;
  }

  componentDidUpdate(prevProps) {
    const {
      location_id_1,
      transfer_date,
      setup_date,
      location_id_2
    } = this.props.formData;
    if (
      transfer_date !== prevProps.formData.transfer_date ||
      setup_date !== prevProps.formData.setup_date ||
      location_id_1 !== prevProps.formData.location_id_1 ||
      location_id_2 !== prevProps.formData.location_id_2
    ) {
      this.setState({ loading: "doing" }, () => {
        this.getAllData();
      });
    }
  }

  checkGpsDevices = (newGpsDevices, gpsDevicesOld) => {
    let problemGps = [];
    gpsDevicesOld.map(async element => {
      const item = find(propEq("id", element.id), newGpsDevices);
      if (isNil(item)) {
        problemGps.push(element);
      }
    });
    return problemGps;
  };

  checkVehicles = (newVehicles, vehiclesOld) => {
    let problemVehicles = [];
    vehiclesOld.map(async element => {
      const item = find(
        propEq("licence_plate", element.licence_plate),
        newVehicles
      );
      if (isNil(item)) {
        problemVehicles.push(element);
      }
    });
    return problemVehicles;
  };

  handleChangeD = (element, type) => {
        const date1 = document.getElementById('transfer_date_E')
        this.props.formData.transfer_date = date1.value
        const newDate2 = moment(date1.value).add(1,'day').format("YYYY-MM-DD")
        const date2 = document.getElementById('setup_date_E')
        date2.min = date1.value
        date2.parseDate = newDate2
        date2.value = newDate2
        this.props.formData.setup_date = newDate2
  }

  async componentDidMount() {
    // this.getAllData();
  }
  render() {
    const { problemVehicles, problemGpsDevices } = this.state;
    // const { problemVehicles, problemGpsDevices, loading } = this.state;
    const { setup_date, transfer_date } = this.props.formData;
    // const pastTransfer = moment(setup_date).isBefore(Date.now());
    const pastTransfer = false; //disable for good

    let disabledSubmit =
      !isEmpty(problemVehicles) || !isEmpty(problemGpsDevices) || pastTransfer;

    return (
      <React.Fragment>
        <DateInput
          label="Transfer Date" id="transfer_date_E" type="date"
          defaultValue={ moment(this.props.formData.transfer_date).format("YYYY-MM-DD") } 
          source="transfer_date" onChange={e => this.handleChangeD(e, "transfer_date_edit")} 
          locales="es-Es" options={{ timeZone: 'UTC' }} 
          disabled={pastTransfer} InputLabelProps={{shrink: true }} 
        />{" "}
        <br />
        <DateInput  locales="es-Es" options={{ timeZone: 'UTC' }} 
          label="Delivery Date" id="setup_date_E"
          source="setup_date"
          disabled={pastTransfer}
        />{" "}
        <br />
        <TextInput label="Agent" source="agent" /> <br />
        <ReferenceInput
          label="Origin"
          source="location_id_1"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <SelectInput
            source="id"
            optionText="location_name"
            disabled={pastTransfer}
          />
        </ReferenceInput>
        <br />
        <ReferenceInput
          label="Destination"
          source="location_id_2"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <SelectInput
            source="id"
            optionText="location_name"
            disabled={pastTransfer}
          />
        </ReferenceInput>
        <br />
        <LongTextInput label="Notes" source="notes" />
        <br />
        {/* <div style={{ with: "100%", textAlign: "right" }}>
          {loading === "done" && !disabledSubmit && <SaveButton />}
          {loading === "doing" && <LinearProgress />}
        </div> */}
        {disabledSubmit && !pastTransfer && (
          <div style={{ with: "100%" }}>
            <p>
              The selected dates / location are not compatible with current
              transfer items. Please check the following items: <br />
            </p>
          </div>
        )}
        {!isEmpty(problemVehicles) && !pastTransfer && (
          <React.Fragment>
            <p>
              Vehicles: <br />
              <br />
              {map(key => {
                return (
                  <React.Fragment key={`f_${key.id}`}>
                    - {prop("licence_plate", key)}
                    <br />
                  </React.Fragment>
                );
              }, problemVehicles)}
            </p>
          </React.Fragment>
        )}
        {!isEmpty(problemGpsDevices) && !pastTransfer && (
          <React.Fragment>
            <p>
              Gps Devices: <br />
              <br />
              {map(key => {
                return (
                  <React.Fragment key={`g_${key.id}`}>
                    - {prop("model", key)}
                    <br />
                  </React.Fragment>
                );
              }, problemGpsDevices)}
            </p>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export const TransferEdit = props => {
  
  const redirect = props.location
  let link = '/transfers'
  if (redirect.search != null) {
    link = `/${redirect.search}` 
    miga = redirect.miga
  } 
  return (
  <Card>
    <div style={{ textAlign: 'right' }}>
      <ReactToPrint
        trigger={() => (
          <Button color="primary" onClick={this.nextClick} title="Print">
            <Print />
          </Button>
        )}
        content={() => this.componentRef}
      />
    </div>
    <Edit title={<TranferEditTitle />} {...props}>
      <TabbedForm
        redirect={link}
        toolbar={<TransferEditToolbar props={{ ...props }}  redirect={link} />}
        validate={validateForm}
      >
        <FormTab label="Transfer Data">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              return (
                <React.Fragment>
                  <AsyncComponent formData={formData} rest={rest} />
                  {/* <SaveButton /> */}
                </React.Fragment>
              );
            }}
          </FormDataConsumer>
        </FormTab>
        <FormTab label="Transfer Items">
          <ReferenceManyField
            addLabel={false}
            reference="transfer_items"
            target="transfer_id"
            perPage={1000}
          >
            <Datagrid>
              <TextField source="item_type" />
              <CustomColumn label="Item" />
              {/* <TextField source="notes" /> */}
              {/* <EditTransferItemButton /> */}
              {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) && 
              <CustomDeleteTransferIten />
              )}
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
        {/* AJUSTES PARA IMPRIMIR EL TRANSFER */}
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            let crearTable = false
            if (typeof formData.gps_devices !== 'undefined') {
              crearTable = (formData.gps_devices.length > 0 || formData.vehicles.length > 0) ? true : false
            } else {
              crearTable = false
            }
            return (
              <React.Fragment>
                <div style={{ display: "none" }}>
                  <ComponentToPrint ref={el => (this.componentRef = el)} >
                    <div style={{ width: "100%" }}>
                      <LogoPrint>
                        <React.Fragment>
                          <table style={{ width: "95%" }}>
                            <td style={{ textAlign: 'left' }}><img src={logo} alt="logo" width="196" class="mcnImage" /></td>
                            <td style={{ textAlign: 'right' }}><h2> TRANSFER {formData.id}</h2></td>
                          </table>
                        </React.Fragment>
                      </LogoPrint>
                      <DatosPrint>
                        <React.Fragment>
                          <DateInput  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}
                            label="Transfer Date"
                            source="transfer_date"
                            style={{ marginRight: '20px' }}
                          />{" "}
                          <DateInput locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}
                            label="Delivery Date"
                            source="setup_date"
                            style={{ marginRight: '20px' }}
                          />{" "}
                          <TextInput label="Agent" source="agent" style={{ marginRight: '20px' }} />
                          <br />
                          <ReferenceInput
                            label="Origin"
                            source="location_id_1"
                            reference="locations"
                            filter={{ only_bases: "true" }}
                            sort={{ field: "location_name", order: "ASC" }}
                            style={{ marginRight: '20px' }}
                          >
                            <SelectInput
                              source="id"
                              optionText="location_name"
                            />
                          </ReferenceInput>
                          <ReferenceInput
                            label="Destination"
                            source="location_id_2"
                            reference="locations"
                            filter={{ only_bases: "true" }}
                            sort={{ field: "location_name", order: "ASC" }}
                            style={{ marginRight: '20px' }}
                          >
                            <SelectInput
                              source="id"
                              optionText="location_name"
                            />
                          </ReferenceInput>
                          <br />
                          <br />
                          {/* <TextInput label="Notes"  fullWidth source="notes" />       */}
                          <label style={{ color: "#ff9800", fontSize: "20px !important" }}>Notes</label>
                          <br />
                          <p style={{ width: "95%", textAlign: "justify" }}>{formData.notes}</p>
                          <br />
                          <br />
                        </React.Fragment>
                        {crearTable &&
                          <table style={{ width: "70%", border: "1px solid black" }}>
                            <tr style={{ border: "1px solid black" }}>
                              <th style={{ backgroundColor: "gray" }}>ITEM TYPE</th>
                              <th style={{ backgroundColor: "gray" }}>MODEL</th>
                              <th style={{ backgroundColor: "gray" }}>ITEM</th>
                            </tr>
                            {formData.gps_devices.map(item => (
                              <React.Fragment key={item.id}>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}>{item.TransferItem.item_type}</td>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}></td>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}>{item.model}</td>
                                </tr>
                              </React.Fragment>
                            ))}

                            {formData.vehicles.map(item => (
                              <React.Fragment key={item.id}>
                                <tr style={{ border: "1px solid black" }}>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}>vehicle</td>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}>{item.model.model_name}</td>
                                  <td style={{ textAlign: "center", border: "1px solid black" }}>{item.licence_plate} {item.renting ? "®" : ""}</td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </table>
                        }
                      </DatosPrint>
                    </div>
                  </ComponentToPrint>
                </div>
              </React.Fragment>
            );
          }}
        </FormDataConsumer>
        {/* AJUSTES PARA IMPRIMIR EL TRANSFER */}
      </TabbedForm>
    </Edit>


  </Card>
)};



// WEBPACK FOOTER //
// ./src/resources/transfers.js